// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605140803/js/" + chunkId + "." + {"44":"04709375","225":"16485d5a","481":"e69491d4","486":"611f7247","770":"25515abb"}[chunkId] + ".0.28934914218876084.chunk.js";
};